module.exports = __webpack_public_path__ + "static/media/yt-smacks-ass.806ca44a.mov";